(function () {

    'use strict';

    if (typeof window === 'undefined') {
        module.exports = exports(
            require('./metric.js'),
            require('./search.js'),
            require('../../enums/metrics.js'),
            require('lodash')
        );
    } else {
        RivalIQ.metric.names = exports(
            RivalIQ.metric,
            RivalIQ.metric.search,
            RivalIQ.enums,
            window._
        );
    }

    function exports(metricFn, search, enums, _) {
        // NOTE only supported client side
        function companyName(metric) {
            return RivalIQ.state.landscape.getCompanyById(metric.companyId).get('name');
        }

        function getClarificationName(metric, dimension) {
            return search.getDimensionValue(metric, ['clarificationName', 'name'], dimension);
        }

        function dimensionName(dimension, value, keys) {
            const metric = metricFn.assign({
                dimensions: [dimension]
            }, [value]);
            return search.getDimensionValue(metric, keys || 'name', dimension);
        }

        function channelName(metric) {
            if (!metric.channel) {
                return 'Cross-Channel';
            }

            return getClarificationName(metric, 'channel');
        }

        function timeAnalysisModeName(metric) {
            if (!_.isUndefined(metric.timeAnalysisMode) && metric.timeAnalysisMode !== enums.timeAnalysisMode.MAIN_PERIOD) {
                return getClarificationName(metric, 'timeAnalysisMode');
            }
        }

        function aggregateName(aggregate) {
            switch (aggregate) {
                case 'average':
                case 'companiesAverage':
                    return 'avg.';

                case 'median':
                case 'companiesMedian':
                    return 'med.';

                case 'sum':
                case 'companiesSum':
                    return 'sum';

                default:
                    return aggregate;
            }
        }

        function metricName(metric, options) {
            options = options || {};

            if (_.isArray(metric)) {
                return multiMetricName(metric, options);
            }

            let name;
            // NOTE special case for a metric that returns the free dimension
            // name
            if (metric.property === 'name') {
                const dimension = _.last(metricFn.getFreeDimensions(metric));
                name = search.getDimensionValue(metric, 'name', dimension);
            } else {
                name = search.getPropertyValue(metric, 'name');
            }

            if (options.abbreviateName) {
                name = RivalIQ.utils.text.abbreviate(name);
            }

            if (options.dimensions) {
                name = clarifyName(metric, name, options.dimensions);
            }

            if (options.includeAggregate && metric.aggregate) {
                name = `${name} (${aggregateName(metric.aggregate)})`;
            }

            return name;
        }

        function getDimensionNames(metric, dimensions) {
            const prefix = [];
            const affix = [];

            _.each(dimensions, function (dimension) {
                switch (dimension) {
                    case 'companyId':
                        prefix.push(companyName(metric));
                        break;
                    case 'channel': {
                        const channel = channelName(metric);
                        prefix.push(channel);
                        break;
                    }
                    case 'day':
                        affix.push('by Day');
                        break;
                    case 'timeAnalysisMode': {
                        const tamName = timeAnalysisModeName(metric);
                        if (tamName) {
                            affix.push(tamName);
                        }
                        break;
                    }
                    default:
                        break;
                }
            });

            return {
                prefix: prefix,
                affix: affix
            };
        }

        function clarifyName(metric, name, dimensions, includeDimensionAggregate) {
            const dimensionNames = getDimensionNames(metric, dimensions);

            if (dimensionNames.prefix.length) {
                name = `${dimensionNames.prefix.join(' ')} ${name}`;
            }

            if (dimensionNames.affix.length) {
                name = `${name}, ${dimensionNames.affix.join(' ')}`;
            }

            if (includeDimensionAggregate) {
                if (metric.companyIdAggregate && _.includes(metric.dimensions, ['companySetId'])) {
                    name = `${name} (${aggregateName(metric.companyIdAggregate)})`;
                }
            }

            return name;
        }

        const MAX_CHANNEL_NAME_COUNT = 2;
        function multiMetricName(metrics, options) {
            options = options || {};

            if (metrics.length === 1) {
                return metricName(metrics[0], options);
            }

            let channels = _.uniq(_.map(metrics, 'channel'));
            if (channels.length <= MAX_CHANNEL_NAME_COUNT) {
                channels = `${_.map(channels, function (channel) {
                    return RivalIQ.data.channels.get(channel).get('name');
                }).join(' and ')} Metrics`;
            } else {
                channels = 'Multi Channel Metrics';
            }

            if (_.includes(options.dimensions, 'companyId')) {
                return [companyName(metrics[0]), channels].join(' ');
            }

            return channels;
        }

        return {
            metricName: metricName,
            clarifyName: clarifyName,
            dimensionName: dimensionName
        };
    }
})();
